import { render } from "./DownloadFileButton.vue?vue&type=template&id=597d6a65"
import script from "./DownloadFileButton.vue?vue&type=script&lang=js"
export * from "./DownloadFileButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__